<template>
  <div>
    <a-button type="primary" ghost="ghost" id="add-headers-button" @click="handleShowModal">
      Agregar cabeceras
    </a-button>

    <a-modal
      v-model:visible="visible"
      :body-style="bodyStyle"
      :closable="false"
      :footer="false"
      :keyboard="false"
      width="808px"
      centered="centered"
      wrapClassName="import-headers-modal"
      :mask-closable="false"
    >
      <section class="modal">
        <a-row :gutter="12">
          <a-col :span="10">
            <span class="modal__title"> Cabeceras </span>
            <CustomScrollbar class="panel" height="70vh">
              <div>
                <a-collapse
                  accordion="accordion"
                  default-active-key="1"
                  expand-icon-position="right"
                >
                  <a-collapse-panel v-if="type === 'client'" key="1">
                    <template v-slot:header>
                      <span>Datos personales &nbsp;</span>
                      <a-tooltip>
                        <template #title>
                          <span>Datos personales de tus contactos importados.</span>
                        </template>
                        <InfoCircleOutlined />
                      </a-tooltip>
                    </template>
                    <div v-for="item in generalHeadersOrdered" :key="item.name">
                      <div class="field" v-if="!isFirstName(item.name)">
                        <a-checkbox :checked="isActive(item)" @change="handleToggle(item)">
                          {{ item.name }}
                        </a-checkbox>
                      </div>
                    </div>
                  </a-collapse-panel>
                  <a-collapse-panel key="2">
                    <template v-slot:header>
                      <span>Datos personalizados &nbsp;</span>
                      <a-tooltip>
                        <template #title>
                          <span>Datos personalizados de tus contactos importados.</span>
                        </template>
                        <InfoCircleOutlined />
                      </a-tooltip>
                    </template>
                    <div v-for="item in headers.custom" :key="item.name" class="field">
                      <a-checkbox :checked="isActive(item)" @change="handleToggle(item)">
                        {{ item.name }}
                      </a-checkbox>
                    </div>
                  </a-collapse-panel>
                  <a-collapse-panel key="3">
                    <template v-slot:header>
                      <span>Datos para filtros &nbsp;</span>
                      <a-tooltip>
                        <template #title>
                          <span
                            >Estos datos serán utilizados para el filtro de tus estrategias.</span
                          >
                        </template>
                        <InfoCircleOutlined />
                      </a-tooltip>
                    </template>
                    <div v-for="item in headers.filters" :key="item.name" class="field">
                      <a-checkbox :checked="isActive(item)" @change="handleToggle(item)">
                        {{ item.name }}
                      </a-checkbox>
                    </div>
                  </a-collapse-panel>
                </a-collapse>
              </div>
            </CustomScrollbar>
          </a-col>

          <a-col :span="14">
            <span class="modal__title">Seleccionadas</span>
            <CustomScrollbar class="panel panel--high" height="70vh">
              <section v-if="!isEmpty(listedFields.general)" class="block">
                <span class="modal__title">Datos personales</span>
                <template v-for="field in listedFields.general" :key="field.name">
                  <div v-if="!isFirstName(field.name)" class="block__row">
                    <div class="block__item">
                      <span>{{ field.name }}</span>
                      <a-tag
                        :color="isSelectField(field) ? 'magenta' : 'gold'"
                        class="block__field-type"
                      >
                        <DownOutlined v-if="isSelectField(field)" />
                        <TextIcon v-else width="12" />
                        <span>{{ isSelectField(field) ? "Lista desplegable" : "Texto" }}</span>
                      </a-tag>
                    </div>
                    <a-tooltip>
                      <template #title>
                        {{
                          isFieldTypeDisabled(field)
                            ? "Este dato solo puede ser de campo tipo texto."
                            : "Editar tipo de campo"
                        }}
                      </template>
                      <a-button
                        type="link"
                        :disabled="isFieldTypeDisabled(field)"
                        class="block__action"
                        @click="openFieldTypeModal(field)"
                      >
                        <EditOutlined class="block__action-icon" />
                      </a-button>
                    </a-tooltip>
                    <a-tooltip>
                      <template #title>
                        Quitar dato
                      </template>
                      <a-button danger type="link" class="block__action" @click="handleRemove(field)">
                        <DeleteOutlined class="block__action-icon" />
                      </a-button>
                    </a-tooltip>
                  </div>
                </template>
              </section>

              <section v-if="!isEmpty(listedFields.custom)" class="block">
                <span class="modal__title">Datos personalizados</span>
                <template v-for="field in listedFields.custom" :key="field.name">
                  <div v-if="!isFirstName(field.name)" class="block__row">
                    <div class="block__item">
                      <span>{{ field.name }}</span>
                      <a-tag
                        :color="isSelectField(field) ? 'magenta' : 'gold'"
                        class="block__field-type"
                      >
                        <DownOutlined v-if="isSelectField(field)" />
                        <TextIcon v-else width="12" />
                        <span>{{ isSelectField(field) ? "Lista desplegable" : "Texto" }}</span>
                      </a-tag>
                    </div>
                    <a-tooltip>
                      <template #title>
                        Editar tipo de campo
                      </template>
                      <a-button
                        type="link"
                        class="block__action"
                        @click="openFieldTypeModal(field)"
                      >
                        <EditOutlined class="block__action-icon" />
                      </a-button>
                    </a-tooltip>
                    <a-tooltip>
                      <template #title>
                        Quitar dato
                      </template>
                      <a-button danger type="link" class="block__action" @click="handleRemove(field)">
                        <DeleteOutlined class="block__action-icon" />
                      </a-button>
                    </a-tooltip>
                  </div>
                </template>
              </section>

              <section v-if="!isEmpty(listedFields.filters)" class="block">
                <span class="modal__title">Datos para filtros</span>
                <template v-for="field in listedFields.filters" :key="field.name">
                  <div v-if="!isFirstName(field.name)" class="block__row">
                    <div class="block__item">
                      <span>{{ field.name }}</span>
                      <a-tag
                        :color="isSelectField(field) ? 'magenta' : 'gold'"
                        class="block__field-type"
                      >
                        <DownOutlined v-if="isSelectField(field)" />
                        <TextIcon v-else width="12" />
                        <span>{{ isSelectField(field) ? "Lista desplegable" : "Texto" }}</span>
                      </a-tag>
                    </div>
                    <a-tooltip>
                      <template #title>
                        Este dato solo puede ser de campo tipo texto.
                      </template>
                      <a-button type="link" disabled class="block__action">
                        <EditOutlined class="block__action-icon" />
                      </a-button>
                    </a-tooltip>
                    <a-tooltip>
                      <template #title>
                        Quitar dato
                      </template>
                      <a-button danger type="link" class="block__action" @click="handleRemove(field)">
                        <DeleteOutlined class="block__action-icon" />
                      </a-button>
                    </a-tooltip>
                  </div>
                </template>
              </section>
            </CustomScrollbar>
          </a-col>
        </a-row>

        <a-row type="flex" justify="space-between" align="middle">
          <span class="footer__help">
            Conoce mejor cómo funcionan las cabeceras dando
            <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer"> click aquí.</a>
          </span>
          <a-space>
            <a-button key="back" @click="handleCancel">Cancelar</a-button>
            <a-button key="submit" type="primary" id="add-header-modal-button" @click="handleOk">
              Guardar
            </a-button>
          </a-space>
        </a-row>
      </section>
    </a-modal>

    <EditFieldTypeModal
      v-model:visible="fieldTypeModalVisible"
      :field="selectedField"
      @save="updateFieldType"
    />
  </div>
</template>

<script>
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import {
  InfoCircleOutlined,
  EditOutlined,
  DeleteOutlined,
  DownOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons-vue";
import { defineComponent, createVNode } from "vue";
import EventBus from "@/app/shared/utils/eventBus";
import TextIcon from "@/app/imports/components/icons/TextIcon.vue";
import EditFieldTypeModal from "@/app/imports/components/modals/modalTemplates/EditFieldTypeModal.vue";
import { Modal, message } from 'ant-design-vue';
import { cloneDeep } from "lodash";

export default defineComponent({
  components: {
    CustomScrollbar,
    InfoCircleOutlined,
    EditOutlined,
    DeleteOutlined,
    TextIcon,
    DownOutlined,
    EditFieldTypeModal,
    ExclamationCircleOutlined,
  },
  props: {
    type: {
      required: true,
      type: String,
      validator: (value) => ["client", "product"].includes(value),
    },
    headers: {
      required: true,
      type: Object,
    },
  },
  data() {
    const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/crm/plantillas-importacion/`;
    return {
      fields: [],
      visible: false,
      bodyStyle: { padding: 0 },
      DOCS_URL: DOCS_URL,
      generalHeadersOrdered: [],
      disabledFieldTypeFields: [
        "paternal_surname",
        "maternal_surname",
        "type_document",
        "document_number",
        "birthdate",
      ],
      fieldTypeModalVisible: false,
      selectedField: null,
      initialPendingTemplateFieldOptions: {},
    };
  },
  created() {
    this.generalHeadersOrdered = this.headers.general;
  },
  mounted() {
    if (this.generalHeadersOrdered) this.formattingGeneralHeaders();
  },
  computed: {
    listedFields() {
      return {
        general: this.getArrayFromHeaderName("general"),
        custom: this.getArrayFromHeaderName("custom"),
        filters: this.getArrayFromHeaderName("filters"),
      };
    },
    cabezeraname() {
      return this.$store.getters["getTemplateClientHeaders"];
    },
  },
  methods: {
    // Handle arrays manipulation
    isEmpty(array) {
      return array?.length == 0;
    },
    isActive(item) {
      const id = item.name;
      const ids = this.fields.map((field) => field.name);
      return ids.includes(id);
    },
    handleToggle(item) {
      if (this.isActive(item)) this.handleRemove(item);
      else this.fields.push({ ...item, name: item.name });
    },
    handleRemove(item) {
      EventBus.emit("NAME_DELETE_ITEM_TEMPLATE", item);
      const i = this.fields.findIndex((field) => field.name == item.name);
      this.fields.splice(i, 1);
    },
    getArrayFromHeaderName(name) {
      return this.fields.filter((field) => {
        const names = this.headers[`${name}`].map((header) => header.name);
        return names.includes(field.name);
      });
    },
    // Handle modal events
    handleOk() {
      this.$store.dispatch("updateTemplateActiveFields", [
        ...this.listedFields.general,
        ...this.listedFields.custom,
        ...this.listedFields.filters,
      ]);
      this.visible = false;
      message.success("Cambios guardados con éxito.")
    },
    handleShowModal() {
      const activeFields = this.$store.getters["getActiveTemplateFields"];
      this.fields = [...activeFields];
      this.initialPendingTemplateFieldOptions = cloneDeep(
        this.$store.getters["getPendingTemplateFieldOptions"],
      );
      this.visible = true;
    },
    handleCancel() {
      Modal.confirm({
        title: "¿Deseas descartar los cambios realizados?",
        content: "Recuerda que si no guardas los cambios que realizaste, estos serán descartados.",
        okText: "Sí, descartar",
        cancelText: "No, seguir editando",
        icon: createVNode(ExclamationCircleOutlined),
        centered: true,
        onOk: () => {
          this.$store.dispatch(
            "replacePendingTemplateFieldOptions",
            this.initialPendingTemplateFieldOptions,
          );
          this.visible = false;
        },
      });
    },
    formattingGeneralHeaders() {
      const orderFields = [
        "first_name",
        "paternal_surname",
        "maternal_surname",
        "type_document",
        "document_number",
      ];

      // Función de comparación para el sort
      const compare = (a, b) => {
        const indexA = orderFields.indexOf(a.name);
        const indexB = orderFields.indexOf(b.name);

        // Si ambos elementos están en el orden, se comparar según su posición en el orden
        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }

        // Si solo uno está en el orden, se coloca primero
        if (indexA !== -1) return -1;
        if (indexB !== -1) return 1;

        // Si ninguno está en el orden, se deja el orden como está
        return 0;
      };

      // Se ordena el array utilizando la función de comparación
      this.generalHeadersOrdered = this.generalHeadersOrdered.sort(compare);
    },
    isCodeClient(name) {
      return name === "code_client";
    },
    isFirstName(name) {
      return name === "first_name";
    },
    isSelectField(field) {
      return field.field_type === "select";
    },
    isFieldTypeDisabled(field) {
      return this.disabledFieldTypeFields.includes(field.name);
    },
    openFieldTypeModal(field) {
      this.selectedField = field;
      this.fieldTypeModalVisible = true;
    },
    updateFieldType(updatedField) {
      const index = this.fields.findIndex((field) => field.name === updatedField.name);
      if (index !== -1) this.fields.splice(index, 1, updatedField);
    },
  },
});
</script>

<style lang="sass" scoped>
.modal
  padding: 12px 24px
  background-color: $gray-2
  width: 100%
  aspect-ratio: 16 / 9

  &__title
    display: inline-block
    color: $gray-9
    font-weight: 600
    margin-bottom: 4px

.panel
  // height: 380px
  // max-height: 380px
  background-color: white
  border-radius: 2px
  border: $border-normal
  margin: 4px 0 12px 0
  padding: 16px

  &--high
    padding: 16px

.field
  padding: 4px 0

.block
  margin-bottom: 12px

  &__row
    display: flex
    width: 100%
    gap: 8px
    align-items: center

  &__item
    font-size: 12px
    display: flex
    align-items: center
    justify-content: space-between
    background-color: #00000005
    border: 1px solid #D9D9D9
    border-radius: 8px
    padding: 2px 8px
    margin: 3px 0
    flex: 1
    width: auto
    height: 38px

  &__icon
    font-size: 10px

  &__field-type
    margin-inline-end: 0
    display: inline-flex
    align-items: center
    justify-content: center
    gap: 4px
    padding: 0 8px

    :deep(.anticon + span)
      margin-inline-start: 0

  &__action
    padding: 0

  &__action-icon
    font-size: 18px

.footer
  &__help
    color: $gray-7
    font-size: 12px
</style>
